import { fetchApi } from '@/services/api';

export interface DemandPlanningSettings {
  forecast_respects_manual_assignments: boolean;
}

export interface ForecastConfigRow {
  id: number;
  scope_type: string;
  scope_id: number | null;
  bucket_granularity: string;
  horizon_periods: number;
  algorithm_code: string;
  outlier_policy: string;
  seasonality_enabled: boolean;
  new_product_policy: string;
  intermittent_policy: string;
  accuracy_metric: string;
  status: string;
}

export const demandPlanningSettingsService = {
  getSettings(): Promise<DemandPlanningSettings> {
    return fetchApi<DemandPlanningSettings>('demand-planning/settings/');
  },

  patchSettings(payload: Partial<DemandPlanningSettings>): Promise<DemandPlanningSettings> {
    return fetchApi<DemandPlanningSettings>('demand-planning/settings/', {
      method: 'PATCH',
      body: payload,
    });
  },

  listForecastConfigs(): Promise<ForecastConfigRow[]> {
    return fetchApi<{ results: ForecastConfigRow[] }>('demand-planning/forecast-configs/', {
      params: { page_size: 50 },
    }).then((data) => data.results ?? []);
  },

  patchForecastConfig(
    id: number,
    payload: Partial<Omit<ForecastConfigRow, 'id' | 'scope_type' | 'scope_id' | 'status'>>,
  ): Promise<ForecastConfigRow> {
    return fetchApi<ForecastConfigRow>(`demand-planning/forecast-configs/${id}/`, {
      method: 'PATCH',
      body: payload,
    });
  },
};
